export default "__VITE_ASSET__BfvVXzgK__"